import { render, staticRenderFns } from "./globalInfo.vue?vue&type=template&id=a2de3c5a&scoped=true&"
import script from "./globalInfo.vue?vue&type=script&lang=js&"
export * from "./globalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2de3c5a",
  null
  
)

export default component.exports